module.exports = __webpack_public_path__ + "img/colorCom.97793d25.png";